import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TheamTemplateModelComponent } from './theam-template-model/theam-template-model.component';
import { DeleteBoxComponent } from '../delete-box/delete-box.component';

@Component({
  selector: 'app-theam-templates',
  standalone: false,
  templateUrl: './theam-templates.component.html',
  styleUrl: './theam-templates.component.scss'
})
export class TheamTemplatesComponent {

  Statuslist: any = [];
  themeTypeSearch: UntypedFormGroup;
  columnDefs: any[];
  tempoperations: any[];
  operations: any[];
  rowData;
  isSettings: boolean = false;
  ProgramList: any[];
  gridApi: any;
  selectedRow: any;
  collapesedOrNot: boolean = false;
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.Statuslist = [
      { "value": "", "label": "All" },
      { "value": "1", "label": "Active" },
      { "value": "0", "label": "Inactive" }

    ];

    this.themeTypeSearch = new UntypedFormGroup({
      NAME: new UntypedFormControl(""),
      BUTTON_BORDER_COLOR: new UntypedFormControl(""),
      BUTTON_HOVER_COLOR: new UntypedFormControl(""),
      BUTTON_TEXT_COLOR: new UntypedFormControl(""),
      HEADER_COLOR: new UntypedFormControl(""),
      LOGIN_BUTTON_COLOR: new UntypedFormControl(""),
      LOGIN_BG_COLOR: new UntypedFormControl(""),
      LOGIN_BUTTON_HOVER: new UntypedFormControl(""),
      LOGIN_BTN_TEXT_COLOR: new UntypedFormControl(""),
      NAV_HOVER_BG: new UntypedFormControl(""),
      RECORD_STATE: new UntypedFormControl(),
      RecordStatus: new UntypedFormControl(""),
      ActiveTheme: new UntypedFormControl(""),
    });

    this.columnDefs = [
      {
        "headerName": "Name",
        "field": "NAME"
      },
      {
        "headerName": "Active Theme",
        "field": "ActiveTheme"
      }
      // {
      //   "headerName": "Status",
      //   "field": "RecordStatus"
      // }
    ];
    this.tempoperations = [];
    
    if (this.commonService.getScreenPermission("633", "V")) {
      this.isSettings = true;
      this.tempoperations.push({
        "name": "View",
        "id": "View"
      });
    }

    if (this.commonService.getScreenPermission("633", "N")) {
      this.tempoperations.push({
        "name": "Add Theme Template",
        "id": "Add"
      });
    }

    if (this.commonService.getScreenPermission("633", "E")) {
      this.isSettings = true;
      this.tempoperations.push({
        "name": "Edit",
        "id": "Edit"
      });
      
    }

    if (this.commonService.getScreenPermission("633", "D")) {
      this.isSettings = true;
      this.tempoperations.push({
        "name": "Delete",
        "id": "Delete"
      });
    }
    this.isSettings = true;
    this.tempoperations.push({
      "name": "Make Default",
      "id": "MakeDefault"
    });
    this.operations = this.tempoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });

    
    this.GetSummary();
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }


  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  Add() {
    let modalRef = this['self'].modalService.open(TheamTemplateModelComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: { id: "" }
    }
    modalRef.result.then(result => {
      this['self'].GetSummary();
    })
  }

  Edit(Record: any) {

    let modalRef = this['self'].modalService.open(TheamTemplateModelComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Edit',
      content: { id: Record['ID'] }
    }
    modalRef.result.then(result => {
      this['self'].GetSummary();
    })
  }

  View(Record: any) {

    const modelRef = this['self'].modalService.open(TheamTemplateModelComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modelRef.componentInstance.Content = {
      heading: 'View',
      content: { id: Record['ID'] }
    }
  }

  MakeDefault(RecordData: any) {
    var id = RecordData["ID"];
    if(RecordData.RECORD_STATE == 0)
    {
      this["self"].commonService.ValidationBanner("Cannot make the inactive themes as default");
    }
    else
    {
      this["self"].summaryService.getSummaryData('api/themetype/makedefault?RecordID=' +id).subscribe(summary => 
        {
          this["self"].commonService.SuccessBanner(summary.Message);
          this['self'].GetSummary();
          setTimeout(() => {
            location.reload();
          },1000);
        });
    }
   
    
  }

  Delete(Record: any) {
    let id = Record['ID'];
    let name = Record['NAME'];
    let message = "";
    const modalRef = this['self'].modalService.open(DeleteBoxComponent, { backdrop: false });
    modalRef.componentInstance.Content = {
      heading: 'Delete',
      custommessage: 'Are you sure you want to delete the Theme Type   ' + "'" + name + "'" + ' ?',
      ProceedButtonName: "Delete",
      TerminateButtonName: "Cancel"
    }
    modalRef.result.then(result => {
      if (result == "okclick")
        this["self"].summaryService.Delete('api/themetype/delete?id=' + id).subscribe(summary => {
          if (summary["Status"] == 0) {
            this["self"].commonService.SuccessBanner(summary.Message);
            this['self'].GetSummary();
          }
          else {
            this["self"].commonService.ValidationBanner(summary.Message);
          }

        });

    })

  };
  GetSummary() {
    this.SearchClear();
    this.summaryService.getSummaryData('api/themetype/SummaryData').subscribe(summary => {
      this.rowData = summary;
    });
  }

  SearchClear() {
    this.themeTypeSearch.patchValue({
      NAME: "",
      RecordStatus: ""
    });
  }

  AdvanceSearch() {
    var formData = this.themeTypeSearch.value;
    this.getSearchData(formData);
  }

  getSearchData(searchData) {
    this.summaryService.AdvanceSearch('api/themetype/search', searchData).subscribe(summary => {
      this.rowData = summary
    });
  }

}
